import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_186: DocMigration = {
  maxSchemaVersion: "0.0.186",
  description: "Add support for elevation drawing annotations.",
  apply(json: any) {
    for (const annotationId in json.annotation) {
      json.annotation[annotationId].referenceFrame = "PLAN";
    }

    return json;
  },
};

export default migration_0_0_186;
